
// export function handleAxiosRes(data, dispatch, overrideMessage = "") {
//     const { status = "error", message } = data;
//     if (status === "error") {
//         const errorMessage = overrideMessage || message?.message || message || "";
//         dispatch(
//             setAlert({ severity: "error", alertTitle: null, message: errorMessage })
//         );
//         if (
//             message ===
//             "Firebase ID token has expired. Get a fresh ID token from your client app and try again (auth/id-token-expired). See https://firebase.google.com/docs/auth/admin/verify-id-tokens for details on how to retrieve an ID token." ||
//             message === "Unauthorized"
//         ) {
//             dispatch(
//                 setAlert({ severity: "error", alertTitle: null, message: errorMessage })
//             ); // dispatch(clearAlert());
//         } else {
//             throw new Error(errorMessage || "Something went wrong");
//         }
//     }
// }

export function getImageURL(path) {
    return "https://www.c4l4cdn.com" + path;
}
